module.exports = __webpack_public_path__ + "static/media/ricaricaPIN.55664db2.svg";